// The approach table: "technical win -> business change -> business value", colored like the
// use-case value slides (light tangerine win, blueberry change = "Calculated", lime value = "Financial
// value"). Shown on the homepage above the Build card. Rows come from `approach-rows.ts`; speaker notes and internal enablement framing
// are deliberately left out (this is shown to customers).

import { approachRows } from './approach-rows';

const ROWS = approachRows();

export function ApproachTable() {
  // One grid for the header and every row (each row is `display: contents`), so the use case labels,
  // the column titles and the cells share tracks, and every body row takes the same height.
  return (
    <div className="vc3-approach">
      <div className="vc3-ap-head" aria-hidden>
        <span />
        <span className="vc3-head-win">Technical win</span>
        <span />
        <span className="vc3-head-change">Business change</span>
        <span />
        <span className="vc3-head-value">Business value</span>
      </div>
      {ROWS.map((row) => (
        <div className="vc3-ap-row" key={row.useCase}>
          <div className="vc3-ap-uc">{row.useCase}</div>
          <div className="vc3-ap-cell vc3-ap-win">{row.win}</div>
          <span className="vc3-ap-arrow" aria-hidden>
            →
          </span>
          <div className="vc3-ap-cell vc3-ap-change">{row.change}</div>
          <span className="vc3-ap-arrow" aria-hidden>
            →
          </span>
          <div className="vc3-ap-cell vc3-ap-value">{row.value}</div>
        </div>
      ))}
    </div>
  );
}
